import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "@tanstack/react-query";
import { SubmitHandler, useForm } from "react-hook-form";
import { useSetRecoilState } from "recoil";
import * as yup from "yup";
import { request } from "../../../lib/api";
import {
  writeAccessToken,
  writeRefreshToken,
} from "../../../lib/authFunctions";
import { User, userState } from "../../../states/user";
import { Button } from "../../atoms/Buttons";
import { InputPassword } from "../../atoms/Inputs/InputPassword";
import { InputText } from "../../atoms/Inputs/InputText";
import * as S from "./loginForm.styles";

import MainLogo from "../../../styles/assets/img/main-logo.png";
import { useNavigate } from "react-router";
interface LoginInputs {
  userId: string;
  password: string;
}

export const LoginForm = () => {
  const setUserState = useSetRecoilState(userState);
  const navigate = useNavigate();
  const schema = yup
    .object({
      userId: yup.string().required("아이디를 입력해주세요."),
      password: yup.string().required("비밀번호를 입력해주세요."),
    })
    .required();

  const { register, handleSubmit } = useForm<LoginInputs>({
    resolver: yupResolver(schema),
  });

  const onSubmit: SubmitHandler<LoginInputs> = async (inputs) => {
    await loginMutation(inputs);
  };

  const { mutateAsync: loginMutation } = useMutation({
    mutationFn: (inputs: LoginInputs) => {
      return request<{
        success: boolean;
        message?: string;
        accessToken?: string;
        refreshToken?: string;
        user: User;
      }>({
        method: "POST",
        url: "auth/sign-in",
        data: inputs,
      });
    },
    onSuccess: (res) => {
      if (res.success) {
        writeAccessToken(res?.accessToken!);
        writeRefreshToken(res?.refreshToken!);
        setUserState(res.user);

        navigate("/");
      } else {
        alert(res.message);
      }
    },
    onError: (e) => {
      alert(e?.message || "서버요청 에러");
    },
  });

  const onUserAccountFindPageMoveHanlder = () => {
    navigate("/user-account-find");
  };

  const onSignUpHandler = () => {
    navigate("/cmp-page");
  };

  return (
    <S.LoginFormLayout>
      <S.LoginForm onSubmit={handleSubmit(onSubmit)}>
        <div
          style={{
            textAlign: "center",
            marginBottom: "30px",
            marginTop: "-130px",
          }}
        >
          <img
            src={MainLogo}
            alt="main-logo"
            style={{
              width: "80px",
              height: "auto",
              marginBottom: "15px",
              display: "flex",
              margin: "0 auto",
            }}
          />
          <div
            style={{
              fontSize: "30px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            타이거페이스
          </div>
          <p
            style={{
              fontSize: "20px",
              fontWeight: "normal",
            }}
          >
            운송기사앱
          </p>
        </div>
        <S.LoginInputBox>
          <InputText
            label="아이디"
            size="full"
            register={register("userId")}
            name="userId"
          />
          <InputPassword
            label="비밀번호"
            size="full"
            register={register("password")}
            name="password"
          />
          {/* <S.UserInfoSaveCheckBox onClick={() => setUserCheck(!userCheck)}>
            {userCheck ? (
              <IconCheckTrue width={24} height={24} />
            ) : (
              <IconCheckFalse width={24} height={24} />
            )}
            로그인 정보 저장
          </S.UserInfoSaveCheckBox> */}
        </S.LoginInputBox>
        <Button type="submit" size="full" label="로그인" />
      </S.LoginForm>
      <S.BottomMoveLayout>
        <S.UserInfoFindAndJoin onClick={onUserAccountFindPageMoveHanlder}>
          계정정보 찾기
        </S.UserInfoFindAndJoin>
        <S.UserInfoFindAndJoin onClick={onSignUpHandler}>
          회원가입
        </S.UserInfoFindAndJoin>
      </S.BottomMoveLayout>
    </S.LoginFormLayout>
  );
};
